import React from "react"

export default class Thumb extends React.Component {
  state = {
    loading: false,
    thumb: undefined
  }

  componentDidMount() {
    this.updateImage()
  }

  updateImage = () => {
    this.setState({ loading: true })
    const image = new Image()
    image.src = this.props.url
    image.onload = () => {
      this.setState(state => ({
        ...state,
        loading: false,
        thumb: image.src
      }))
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.updateImage()
    }
  }

  render() {
    const { url } = this.props
    // const { loading, thumb } = this.state

    if (!url) {
      return null
    }

    // if (loading) {
    //   return <p>loading...</p>
    // }

    return (
      <img className="thumb" src={url} alt={url} height={200} width={200} />
    )
  }
}
